<script type="ts">
	import type { BeautifiedCode } from 'src/app';
	import Code from './Code.svelte';

	import { page } from '$app/stores';
	import { browser } from '$app/env';

	export let data: BeautifiedCode.Partial;
	export let group: string = 'strategy';

	function unminifyTokens(data: [string, string][][]): BeautifiedCode.Token[][] {
		return data.map((line) => {
			return line.map((token) => {
				const [content, color] = token;
				return { content, color };
			});
		});
	}

	function getCode(
		examples: BeautifiedCode.MinifiedTokens,
		data: BeautifiedCode.Partial
	): BeautifiedCode.Token[][] {
		const partialKey = data.key;
		const minifiedTokens = examples[partialKey];
		if (!minifiedTokens) {
			console.log(`No example for group "${group}"`);
		}
		return unminifyTokens(minifiedTokens);
	}

	let tokens;
	$: if ( browser ) {
		tokens = getCode($page.stuff.hydratedExamples, data);
	}
</script>

{#if tokens}
	<Code code={data.content} {tokens} />
{:else}
	<Code code={data.content} />
{/if}
